const bases= {
    sso: {
        api: process.env.VUE_APP_SSO_API_BASE_URL,
            ui: process.env.VUE_APP_SSO_WEB_BASE_URL,
    },
    members: {
        api: process.env.VUE_APP_MEMBERS_API_BASE_URL,
            ui: process.env.VUE_APP_MEMBERS_WEB_BASE_URL,
    },
    training: {
        api: process.env.VUE_APP_TRAINING_API_BASE_URL,
            ui: process.env.VUE_APP_TRAINING_WEB_BASE_URL,
    }
};

export default {
    routes: {
        leader: {
            edit: `${bases.training.ui}/leader`
        }

    }
}


